<div
  [class.mb-4]="withBottomMargin()"
  class="flex flex-col">
  @if (floatLabel()) {
    <p-float-label>
      <div class="mb-2 flex flex-col">
        <ng-container *ngTemplateOutlet="formControlTemplateRef" />
      </div>

      @if (shouldShowLabel()) {
        <ng-container *ngTemplateOutlet="labelTemplateRef" />
      }
    </p-float-label>
  } @else {
    @if (shouldShowLabel()) {
      <p appLabelStyle>
        <ng-container *ngTemplateOutlet="labelTemplateRef" />
      </p>
    }

    <div class="mb-2 flex flex-col">
      <ng-container *ngTemplateOutlet="formControlTemplateRef" />
    </div>
  }

  @if (shouldShowHint()) {
    <div [class.ml-3]="underlineInputStyle()">
      <app-form-control-hint [hint]="hint()!" />
    </div>
  }

  @if (errors) {
    <app-form-control-errors [errors]="errors" />
  }
</div>

<ng-template #formControlTemplateRef>
  <ng-content />
</ng-template>

<ng-template #labelTemplateRef>
  <label [for]="inputId()">
    <span>{{ label() }}</span>

    @if (requirementHint()) {
      @if (hasRequiredValidator) {
        <app-form-control-required-asterix />
      }
    }
  </label>
</ng-template>
